import axios from 'axios';
import { format } from 'date-fns';
import download from 'downloadjs';
import { toast } from 'react-toastify';
import { baseURL, unifiedBaseURL } from './api';

const path = process.env.REACT_APP_BASE_URL + '/api/v2';
export const baseURLV3 = 'http://localhost:3000/api/v3';
const pathV3 = process.env.REACT_APP_BASE_URL + '/api/v3';

const localFaxes = [
  {
    _id: 'INC_FAX_1',
    email: 'a@a.com',
    attachmentPath: '/',
    faxNum: '123123',
    type: 'Incoming',
    status: 'Sent',
    reason: 'Sending fax',
    retryCount: 0,
    updatedOn: '0',
  },
  {
    _id: 'INC_FAX_2',
    email: 'b@a.com',
    attachmentPath: '/',
    faxNum: '123123',
    type: 'Incoming',
    status: 'Sent',
    reason: 'Sending fax',
    retryCount: 0,
    updatedOn: '0',
  },
  {
    _id: 'INC_FAX_3',
    email: 'c@a.com',
    attachmentPath: '/',
    faxNum: '123123',
    type: 'Incoming',
    status: 'Sent',
    reason: 'Sending fax',
    retryCount: 0,
    updatedOn: '0',
  },
  {
    _id: 'INC_FAX_4',
    email: 'd@a.com',
    attachmentPath: '/',
    faxNum: '123123',
    type: 'Outgoing',
    status: 'Sent',
    reason: 'Sending fax',
    retryCount: 0,
    updatedOn: '0',
  },
  {
    _id: 'INC_FAX_5',
    email: 'e@a.com',
    attachmentPath: '/',
    faxNum: '123123',
    type: 'Outgoing',
    status: 'retrying',
    reason: 'Retying fax.',
    retryCount: 2,
    updatedOn: '0',
  },
  {
    _id: 'INC_FAX_6',
    email: 'f@a.com',
    attachmentPath: '/',
    faxNum: '123123',
    type: 'Outgoing',
    status: 'sending',
    reason: 'Sending in progress...',
    retryCount: 0,
    updatedOn: '0',
  },
  {
    _id: 'INC_FAX_7',
    email: 'g@a.com',
    attachmentPath: '/favico.ico',
    faxNum: '123123',
    type: 'Outgoing',
    status: 'failed',
    reason: 'Failed to send fax.',
    retryCount: 0,
    updatedOn: '0',
  },
];

const localOutgoingFaxes = [
  { _id: 'OUT_FAX_1' },
  { _id: 'OUT_FAX_2' },
  { _id: 'OUT_FAX_3' },
  { _id: 'OUT_FAX_4' },
  { _id: 'OUT_FAX_5' },
  { _id: 'OUT_FAX_6' },
  { _id: 'OUT_FAX_7' },
];

class FaxService {
  static baseURL = baseURL;

  static resourcePath = path || '';
  static baseURLV3 = baseURLV3;

  static resourcePathV3 = pathV3 || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
  }

  getBaseURL = () => {
    return this.baseURL || FaxService.resourcePath || FaxService.baseURL;
  };

  getBaseURLV3 = () => {
    return this.baseURL || FaxService.resourcePathV3 || FaxService.baseURLV3;
  };

  getUnifiedBaseURLV3 = (dc) => {
    return `${unifiedBaseURL(dc)}v3` || this.baseURL || FaxService.resourcePathV3 || FaxService.baseURLV3;
  };

  getPaginateOptions = options => {
    return JSON.stringify(options || { page: 1, limit: 10 });
  };

  // GET /api/faxes/outgoing
  async getIncomingFaxes(paginateOptions, dateFilter = ['', ''], getDeleted = global.deleteMode) {
    if (this.demo) {
      return Promise.resolve(localFaxes);
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}/faxes/incomingFaxes/?paginateOptions=${options}&from=${
        dateFilter[1]
      }&to=${dateFilter[0]}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getIncomingFaxesFilter(
    companyId,
    paginateOptions,
    date = ['', ''],
    getDeleted = global.deleteMode,
  ) {
    if (this.demo) {
      return Promise.resolve(localFaxes);
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}/companies/${companyId}/incomingFaxes/?paginateOptions=${options}&from=${
        date[1]
      }&to=${date[0]}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getOutgoingFaxesByUser(
    userID,
    paginateOptions,
    date = ['', ''],
    relay,
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}/users/${userID}/outgoingFaxes/?paginateOptions=${options}&relay=${relay}&from=${
        date[1]
      }&to=${date[0]}&getDeleted=${getDeleted}`,
      { headers },
    );

    return data;
  }

  async getIncomingFaxesByUser(
    userID,
    paginateOptions,
    date = ['', ''],
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}/users/${userID}/incomingFaxes/?paginateOptions=${options}&from=${
        date[1]
      }&to=${date[0]}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getAllPendingFaxesApi(query) {
    try {
      const headers = {
        Authorization: `Bearer ${this.api.token}`,
      };
      const { data } = await axios.get(`${this.getBaseURLV3()}/faxes/pending`, {
        headers,
        params: query,
      });
      return data;
    } catch (error) {
      return false;
    }
  }
  async deleteFaxApi(id, dataCenter) {
    try {
      const headers = {
        Authorization: `Bearer ${this.api.token}`,
      };

      const { data } = await axios.delete(`${this.getUnifiedBaseURLV3(dataCenter)}/faxes/delete/${id}`, {
        headers,
      });
      return data;
    } catch (error) {
      throw error
    }
  }
  async getFaxesSummaryV2Api(query) {
    try {
      const headers = {
        Authorization: `Bearer ${this.api.token}`,
      };
      const { data } = await axios.get(`${this.getBaseURLV3()}/faxes/summary`, {
        headers,
        params: query,
      });
      return data;
    } catch (error) {
      return false;
    }
  }
  async getFaxesFailSummaryV2Api(query) {
    try {
      const headers = {
        Authorization: `Bearer ${this.api.token}`,
      };
      const { data } = await axios.get(`${this.getBaseURLV3()}/faxes/fail-summary`, {
        headers,
        params: query,
      });
      return data;
    } catch (error) {
      return false;
    }
  }
  async getAllProcessedFaxesApi(query) {
    try {
      const headers = {
        Authorization: `Bearer ${this.api.token}`,
      };
      const { data } = await axios.get(`${this.getBaseURLV3()}/faxes/processed`, {
        headers,
        params: query,
      });
      return data;
    } catch (error) {
      return false;
    }
  }

  async getFaxesFailureSummaryByCompany(id, date = ['', ''], getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}/companies/${id}/outgoingFaxes/failureSummary?from=${date[1]}&to=${
        date[0]
      }&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getFaxesSummaryByCompany(id, date = ['', ''], getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}/companies/${id}/outgoingFaxes/summary?from=${date[1]}&to=${
        date[0]
      }&getDeleted=${getDeleted}`,
      { headers },
    );

    return data;
  }

  async getFaxesSummaryByUser(id, date, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}/users/${id}/outgoingFaxes/summary?from=${date[1]}&to=${
        date[0]
      }&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getFaxesFailureSummaryByUser(id, date = ['', ''], getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}/users/${id}/outgoingFaxes/failureSummary?from=${date[1]}&to=${
        date[0]
      }&getDeleted=${getDeleted}`,
      { headers },
    );

    return data;
  }

  async faxNumberFilterSummary(number, type, date = ['', ''], getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}/faxes/outgoingFaxes/summary/${number}?type=${type}&from=${date[1]}&to=${
        date[0]
      }&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getFaxesSummary(date, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}/faxes/outgoingFaxes/summary?from=${date[1]}&to=${
        date[0]
      }&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async faxNumberFilterFailureSummary(
    number,
    type,
    date = ['', ''],
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}/faxes/outgoingFaxes/failureSummary/${number}?type=${type}&from=${
        date[1]
      }&to=${date[0]}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getFaxesFailureSummary(date, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}/faxes/outgoingFaxes/failureSummary?from=${date[1]}&to=${
        date[0]
      }&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getOutgoingFaxesFilter(
    companyId,
    paginateOptions,
    date = ['', ''],
    relay,
    getDeleted = global.deleteMode,
  ) {
    if (this.demo) {
      return Promise.resolve(localOutgoingFaxes);
    }

    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}/companies/${companyId}/outgoingFaxes/?paginateOptions=${options}&relay=${relay}&from=${
        date[1]
      }&to=${date[0]}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  // GET /api/faxes/incoming
  async getOutgoingFaxes(
    paginateOptions,
    dateFilter = ['', ''],
    relay = false,
    getDeleted = global.deleteMode,
  ) {
    if (this.demo) {
      return Promise.resolve(localOutgoingFaxes);
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}/faxes/outgoingFaxes/?paginateOptions=${options}&relay=${relay}&from=${
        dateFilter[1]
      }&to=${dateFilter[0]}&getDeleted=${getDeleted}`,
      { headers },
    );

    return data;
  }

  async outgoingfaxFilterByNumber(
    type,
    value,
    date = ['', ''],
    paginateOptions,
    relay,
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}/faxes/outgoingFaxes/filter/?type=${type}&relay=${relay}&value=${encodeURIComponent(
        value,
      )}&from=${date[1]}&to=${date[0]}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async incomingfaxFilterByNumber(
    type,
    value,
    date = ['', ''],
    paginateOptions,
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}/faxes/incomingFaxes/filter/?type=${type}&value=${encodeURIComponent(
        value,
      )}&from=${date[1]}&to=${date[0]}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async onRecoverIncomingFax(faxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const data = await axios.patch(
      `${this.getBaseURL()}/faxes/incomingFaxes/${faxId}`,
      {
        deleted: false,
      },
      { headers },
    );
    return data;
  }

  async onRecoverOutgoingFax(faxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const data = await axios.patch(
      `${this.getBaseURL()}/faxes/outgoingFaxes/${faxId}`,
      {
        deleted: false,
      },
      { headers },
    );
    return data;
  }

  async onCancelFax(faxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const data = await axios.put(
      `${this.getBaseURL()}/faxes/outgoingFaxes/${faxId}/cancel`,
      {},
      { headers },
    );
    return data;
  }

  async onResendFax(faxId, relay) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const data = await axios.put(
      `${this.getBaseURL()}/faxes/outgoingFaxes/${faxId}/retry?relay=${relay}`,
      {},
      { headers },
    );
    return data;
  }

  // DELETE /api/faxes/:id
  async deleteOutgoingFax(id, hardDelete = global.deleteMode ? 'yes' : 'no') {
    if (this.demo) {
      const faxIndex = localFaxes.findIndex(({ _id }) => _id === id);
      if (faxIndex === -1) {
        return;
      }
      localFaxes.splice(faxIndex, 1);
      return Promise.resolve();
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(
      `${this.getBaseURL()}/faxes/outgoingFaxes/${id}?hardDelete=${hardDelete}`,
      { headers },
    );
    return data;
  }

  async deleteIncomingFax(id, hardDelete = global.deleteMode ? 'yes' : 'no') {
    if (this.demo) {
      const faxIndex = localFaxes.findIndex(({ _id }) => _id === id);
      if (faxIndex === -1) {
        return;
      }
      localFaxes.splice(faxIndex, 1);
      return Promise.resolve();
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(
      `${this.getBaseURL()}/faxes/incomingFaxes/${id}?hardDelete=${hardDelete}`,
      { headers },
    );
    return data;
  }

  // GET /api/faxes/:id/download
  // GET /api/faxes/incoming/<faxId>?uid=<userID>
  async downloadIncomingFax(id, userID) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    try {
      const res = await axios.get(
        `${this.getBaseURL()}/faxes/incomingFaxes/${id}/download?uid=${userID}`,
        {
          headers,
          responseType: 'blob',
        },
      );
      download(res.data, `Fax-${id}.pdf`, 'application/pdf');
    } catch (error) {
      const { status } = error.response;
      if (status === 500) {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_UNIFIED_URL}v2/faxes/incomingFaxes/${id}/download?uid=${userID}`,
            {
              headers,
              responseType: 'blob',
            },
          );
          download(res.data, `Fax-${id}.pdf`, 'application/pdf');
        } catch (error) {}
      }
    }
  }

  async downloadOutgoingFax(id, userID) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    try {
      const res = await axios.get(
        `${this.getBaseURL()}/faxes/outgoingFaxes/${id}/download?uid=${userID}`,
        {
          headers,
          responseType: 'blob',
        },
      );
      download(res.data, `Fax-${id}.pdf`, 'application/pdf');
    } catch (error) {
      const { status } = error.response;
      if (status === 500) {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_UNIFIED_URL}v2/faxes/outgoingFaxes/${id}/download?uid=${userID}`,
            {
              headers,
              responseType: 'blob',
            },
          );
          download(res.data, `Fax-${id}.pdf`, 'application/pdf');
        } catch (error) {}
      }
    }
  }

  async downloadFaxFailureSummaryByCompany(id, date, type) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    try {
      const data = await axios.get(
        `${this.getBaseURL()}/companies/${id}/outgoingFaxes/summary/download/?from=${date[1]}&to=${
          date[0]
        }&reportOf=${type}`,
        {
          headers,
          responseType: 'blob',
        },
      );
      const file = new Blob([data.data], { type: 'text/csv' });
      const fileURL = URL.createObjectURL(file);
      let a = document.createElement('a');
      a.href = fileURL;
      if (type === 'allByCompany') {
        if (date[0] === '') {
          a.download = `Fax Summary`;
        } else {
          a.download = `Fax Summary - ${format(date[1], 'MM-DD-YY')} to ${format(
            date[0],
            'MM-DD-YY',
          )}`;
        }
      } else {
        if (date[0] === '') {
          a.download = `Failure Summary`;
        } else {
          a.download = `Failure Summary - ${format(date[1], 'MM-DD-YY')} to ${format(
            date[0],
            'MM-DD-YY',
          )}`;
        }
      }
      a.click();
    } catch (error) {
      console.log('error :: ', error);
    }
  }

  async downloadFaxSummaryByUser(id, date, type) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    try {
      const data = await axios.get(
        `${this.getBaseURL()}/users/${id}/outgoingFaxes/summary/download/?from=${date[1]}&to=${
          date[0]
        }&reportOf=${type}`,
        {
          headers,
          responseType: 'blob',
        },
      );
      const file = new Blob([data.data], { type: 'text/csv' });
      const fileURL = URL.createObjectURL(file);
      let a = document.createElement('a');
      a.href = fileURL;

      if (type === 'allByUser') {
        if (date[0] === '') {
          a.download = `Fax Summary`;
        } else {
          a.download = `Fax Summary - ${format(date[1], 'MM-DD-YY')} to ${format(
            date[0],
            'MM-DD-YY',
          )}`;
        }
      } else {
        if (date[0] === '') {
          a.download = `Failure Summary`;
        } else {
          a.download = `Failure Summary - ${format(date[1], 'MM-DD-YY')} to ${format(
            date[0],
            'MM-DD-YY',
          )}`;
        }
      }
      a.click();
    } catch (error) {
      console.log('error :: ', error);
    }
  }

  async numberSummary(reportOf, type, date = ['', ''], getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    try {
      const data = await axios.get(
        `${this.getBaseURL()}/faxes/outgoingFaxes/numberSummary/download/?reportOf=${reportOf}&from=${
          date[1]
        }&to=${date[0]}&type=${type}&getDeleted=${getDeleted}`,
        {
          headers,
          responseType: 'blob',
        },
      );
      const file = new Blob([data.data], { type: 'text/csv' });
      const fileURL = URL.createObjectURL(file);
      let a = document.createElement('a');
      a.href = fileURL;

      if (reportOf === 'allByNumber') {
        if (date[0] === '') {
          a.download = `Fax Number Summary`;
        } else {
          a.download = `Fax Number Summary - ${format(date[1], 'MM-DD-YY')} to ${format(
            date[0],
            'MM-DD-YY',
          )}`;
        }
      } else {
        if (date[0] === '') {
          a.download = `Failure Summary`;
        } else {
          a.download = `Failure Summary - ${format(date[1], 'MM-DD-YY')} to ${format(
            date[0],
            'MM-DD-YY',
          )}`;
        }
      }
      a.click();
    } catch (error) {
      console.log('error :: ', error);
    }
  }

  async downloadFaxSummary(date, type = 'all') {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    try {
      const data = await axios.get(
        `${this.getBaseURL()}/faxes/outgoingFaxes/summary/download/?from=${date[1]}&to=${
          date[0]
        }&reportOf=${type}`,
        {
          headers,
          responseType: 'blob',
        },
      );
      const file = new Blob([data.data], { type: 'text/csv' });
      const fileURL = URL.createObjectURL(file);
      let a = document.createElement('a');
      a.href = fileURL;

      if (type === 'all') {
        if (date[0] === '') {
          a.download = `Fax Summary`;
        } else {
          a.download = `Fax Summary - ${format(date[1], 'MM-DD-YY')} to ${format(
            date[0],
            'MM-DD-YY',
          )}`;
        }
      } else {
        if (date[0] === '') {
          a.download = `Failure Summary`;
        } else {
          a.download = `Failure Summary - ${format(date[1], 'MM-DD-YY')} to ${format(
            date[0],
            'MM-DD-YY',
          )}`;
        }
      }
      a.click();
    } catch (error) {
      console.log('error :: ', error);
    }
  }

  async sendFax(body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    }
    const  data  = await axios.post(`${this.getBaseURL()}/faxes/sendFax`, body,
      { headers }
    );
    return data;
  }

  async checkPendingFaxes(number) {
    try {
      const headers = {
        Authorization: `Bearer ${this.api.token}`,
      };
      const { data } = await axios.get(`${this.getBaseURLV3()}/faxes/checkPending/${number}`, {
        headers,
        params: {number},
      });
      return data;
    } catch (error) {
      console.log('checkpendingfax error', error)
      return true;
    }
  }
}

export default FaxService;
